import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { map } from 'lodash';
import Button from 'reactstrap/lib/Button';
import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';
import Moment from 'react-moment';
import 'react-widgets/dist/css/react-widgets.css';
import * as constants from '../../../constants/constants';
import {
  getSuspiciousRoomLeftPlayers,
  getSuspiciousLeavingRoomData,
} from '../../../actions/admin';
import PaginationOld from '../Menu/PaginationOld';

const SuspiciousRoomLeftPlayers = ({ openRoomModal, offset }) => {
  const { t } = useTranslation('admin');
  const dispatch = useDispatch();

  const allSuspiciousRoomLeftPlayers = useSelector(state => state.admin.suspiciousRoomLeftPlayers || []);
  const suspiciousLeavingRoomData = useSelector(state => state.admin.suspiciousLeavingRoomData || {});

  const [openModal, setOpenModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const pageSize = 50;

  useEffect(() => {
    dispatch(getSuspiciousRoomLeftPlayers());
  }, []);

  const handlePagination = (e, index) => {
    e.preventDefault();
    setCurrentPage(index);
  };

  const openModalFunc = (item) => {
    setOpenModal(true);
    dispatch(getSuspiciousLeavingRoomData(item.uid));
  };

  const closeModalFunc = () => {
    setOpenModal(false);
  };

  const pagesCount = Math.ceil(allSuspiciousRoomLeftPlayers.length / pageSize);

  return (
    <Fragment>
      <table style={{ width: '100%', fontSize: 12, color: '#fff' }}>
        <colgroup>
          <col span="1" className="" />
        </colgroup>
        <thead>
          <tr>
            <th style={{ textAlign: 'center' }}>
              Date
            </th>
            <th style={{ textAlign: 'center' }}>
              Name
            </th>
            <th style={{ textAlign: 'center' }}>
              Player Id
            </th>
            <th style={{ textAlign: 'center' }}>
              Count
            </th>
            <th style={{ textAlign: 'center' }}>
              View
            </th>
          </tr>
        </thead>
        <tbody>
          {allSuspiciousRoomLeftPlayers && map(allSuspiciousRoomLeftPlayers.slice(currentPage * pageSize, (currentPage + 1) * pageSize), (item, key) => (
            <Fragment key={key}>
              <tr key={key} className="allUsers-table-row">
                <td className="allUsers-table-col">
                  <Moment format="DD-MM-YYYY, HH:mm:ss" locale="lv">
                    {item.date + offset}
                  </Moment>
                </td>
                <td className="allUsers-table-col">
                  {item.name}
                </td>
                <th style={{ textAlign: 'center' }}>
                  {item.uid}
                </th>
                <td className="allUsers-table-col">
                  {item.count}
                </td>
                <td className="allUsers-table-col">
                  <Button onClick={() => openModalFunc(item)}>
                    View
                  </Button>
                </td>
              </tr>
            </Fragment>
          ))}
        </tbody>
      </table>

      <PaginationOld
        show
        currentPage={currentPage}
        pagesCount={pagesCount}
        handlePagination={handlePagination}
      />

      <Modal container={'div > div'} isOpen={openModal} toggle={closeModalFunc} size="lg">
        <ModalHeader toggle={closeModalFunc}>
          Leaving Rooms
        </ModalHeader>
        <ModalBody>
          <table style={{ width: '100%', fontSize: 12, color: '#fff' }}>
            <colgroup>
              <col span="1" className="" />
            </colgroup>
            <thead>
              <tr className="allUsers-table-row">
                <th style={{ textAlign: 'center' }}>
                  Date
                </th>
                <th style={{ textAlign: 'center' }}>
                  Room Id
                </th>
                <th style={{ textAlign: 'center' }}>
                  Bet
                </th>
                <th style={{ textAlign: 'center' }}>
                  Min Games
                </th>
                <th style={{ textAlign: 'center' }}>
                  Room Completed
                </th>
                <th style={{ textAlign: 'center' }}>
                  View
                </th>
              </tr>
            </thead>
            <tbody>
              {
                map(suspiciousLeavingRoomData, (item, key) => (
                  <Fragment key={key}>
                    <tr className="allUsers-table-row">
                      <td className="allUsers-table-col">
                        <Moment format={constants.FORMAT_DATE_TYPE.fullDateSecond} locale={constants.sendLanguage.lv}>
                          {item.date}
                        </Moment>
                      </td>
                      <td className="allUsers-table-col">
                        {item.roomId}
                      </td>
                      <td className="allUsers-table-col">
                        {item.bet}
                      </td>
                      <td className="allUsers-table-col">
                        {item.minGames}
                      </td>
                      <td className="allUsers-table-col">
                        {item.rPlayed >= item.minGames ? 'Yes' : 'No'}
                      </td>
                      <td className="allUsers-table-col">
                        <Button onClick={() => openRoomModal(item)}>
                          View
                        </Button>
                      </td>
                    </tr>
                  </Fragment>
                ))
              }
            </tbody>
          </table>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={closeModalFunc}>Close</Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

SuspiciousRoomLeftPlayers.propTypes = {
  member: PropTypes.shape({
    email: PropTypes.string,
  }),
  allSuspiciousRoomLeftPlayers: PropTypes.shape({}),
};

SuspiciousRoomLeftPlayers.defaultProps = {
  member: {},
  allSuspiciousRoomLeftPlayers: [],
};

export default SuspiciousRoomLeftPlayers;
